import {
	getController,
	type HpRequestOptional,
	apiService as Service,
} from '@/services/service'

const url = 'notestype'

export const noteTypeService = {
	...getController<Api.NoteType, Api.NoteTypePostInput, Api.NoteTypePostInput>(
		url
	),
	index: (data?: HpRequestOptional) =>
		Service.get<Api.Collection<Api.NoteType>>({
			url: `${url}?of=name&od=ASC`,
			...data,
		}),
}

export default noteTypeService
